import { Link, NavLink, Outlet } from 'react-router-dom';
import { SITE_GLASS_CARD } from '../constants/siteUi';

const navItem = ({ isActive }: { isActive: boolean }) =>
  `block rounded-lg px-3 py-2 text-sm transition ${
    isActive
      ? 'bg-[var(--home-miami-blue)]/[0.2] font-medium text-[var(--home-text-on-dark)] ring-1 ring-white/12'
      : 'text-[var(--home-muted-on-dark)] hover:bg-white/[0.06] hover:text-[var(--home-text-on-dark)]'
  }`;

export function InvestorLayout() {
  return (
    <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-4 py-10 md:px-6 lg:flex-row">
      <aside className={`${SITE_GLASS_CARD} shrink-0 space-y-6 p-5 lg:w-56`}>
        <div>
          <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[var(--home-muted-on-dark)]">
            Investor portal
          </p>
          <nav className="space-y-1">
            <NavLink to="/dashboard" end className={navItem}>
              Portfolio
            </NavLink>
            <NavLink to="/dashboard/offerings" className={navItem}>
              Offerings
            </NavLink>
            <NavLink to="/dashboard/tools" className={navItem}>
              Tools
            </NavLink>
            <NavLink to="/dashboard/analyzer" className={navItem}>
              Deal analyzer
            </NavLink>
            <NavLink to="/dashboard/ai-api-settings" className={navItem}>
              Analyzer API keys
            </NavLink>
            <NavLink to="/dashboard/saved-analyses" className={navItem}>
              Saved analyses
            </NavLink>
            <NavLink to="/dashboard/resources" className={navItem}>
              Resources
            </NavLink>
            <NavLink to="/dashboard/events" className={navItem}>
              Events
            </NavLink>
            <NavLink to="/dashboard/account" className={navItem}>
              Account
            </NavLink>
          </nav>
        </div>
        <Link
          to="/"
          className="text-xs font-medium text-[var(--home-miami-blue)] underline-offset-4 hover:underline"
        >
          ← Marketing site
        </Link>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
